import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class MessageService {

  errorMessage: string = "";

  constructor(private http: Http) { }

  public getErrorMessageByKey(key: string): Observable<any> {
    let apiURL = 'assets/resources/errormessages.json';
    return this.http.get(apiURL)
      .map((res: any) => {
        if (res.json() && res.json().HTTPErrors) {
          res.json().HTTPErrors.forEach(element => {
            if (element.name == key)
              this.errorMessage = element.message;
          });
        }
        return res.json() || {};
      })
      .catch((err: Response) => {
        return Observable.throw(err);
      });

  }

}
